import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  titleContainer: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    marginBottom: theme.spacing(4)
  },
  icon: {
    marginLeft: theme.spacing(0.75),
    color: '#C4C4D1',
    width: theme.spacing(2.5),
    height: theme.spacing(2.5)
  }
}))
